import { use } from 'react';

import type { AvailabilityContextType } from '../contexts/AvailabilityContext';
import { AvailabilityContext } from '../contexts/AvailabilityContext';

export const useAvailability = (): AvailabilityContextType => {
  const context = use(AvailabilityContext);
  if (context === undefined) {
    throw new Error('useAvailability must be used within an AvailabilityProvider');
  }
  return context;
};
